var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("ita_btn_notify_client"),
        visible: _vm.hereShow,
        width: "60%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.hereShow = $event
        },
      },
    },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              staticStyle: { "margin-bottom": "10px" },
              attrs: { "label-width": "200px", "label-position": "left" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("recevier") } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { multiple: "", filterable: "", clearable: "" },
                      model: {
                        value: _vm.recevier,
                        callback: function ($$v) {
                          _vm.recevier = $$v
                        },
                        expression: "recevier",
                      },
                    },
                    _vm._l(_vm.options, function (v, k) {
                      return _c("el-option", {
                        key: k,
                        attrs: { label: v.userName, value: v.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("ccer") } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { multiple: "", filterable: "", clearable: "" },
                      model: {
                        value: _vm.cc,
                        callback: function ($$v) {
                          _vm.cc = $$v
                        },
                        expression: "cc",
                      },
                    },
                    _vm._l(_vm.ccOptions, function (v, k) {
                      return _c("el-option", {
                        key: k,
                        attrs: { label: v.userName, value: v.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "cancel-btn",
              attrs: { loading: _vm.loading },
              on: {
                click: function ($event) {
                  _vm.show = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("btn_cancel")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "cancel-btn",
              attrs: { type: "primary", loading: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.onSend("myself")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("send_me_a_preview")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.onSend },
            },
            [_vm._v(_vm._s(_vm.$t("comment_send")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }